module.exports = __webpack_public_path__ + "static/img/preview-05.547305c8.webp";